export default class Token {
  value: string;

  constructor(entity: Token) {
    this.value = entity.value;
  }
}



// WEBPACK FOOTER //
// ./src/value-objects/Token.tsx